// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group.keyword[data-v-07cac931]{position:relative}.clear-keyword[data-v-07cac931]{position:absolute;bottom:1px;right:35px;z-index:9}.or[data-v-07cac931]{position:absolute;background-color:#fff;left:0;right:0;width:54px;margin:auto;top:5px;font-size:26px;text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
